<template>
    <el-dialog :title="(codeId === null ? $t('common.create') : $t('common.update')) + ' ' + $t('masters.resolutionCode')" :visible.sync="showDialog" @open="loadCode" @close="closeDialog" width="500px" :close-on-click-modal="false">
        <el-form v-loading="loading" ref="form" :model="form" :rules="rules" size="small" label-width="140px" label-position="left">
            <el-form-item :label="$t('common.product')" prop="productId">
                <product-selector v-model="form.productId"></product-selector>
            </el-form-item>

            <el-form-item :label="$t('common.category')" prop="categoryId">
                <resolution-category-selector v-model="form.categoryId" :productId="form.productId"></resolution-category-selector>
            </el-form-item>

            <el-form-item :label="$t('common.code')" prop="code">
                <el-input v-model="form.code"></el-input>
            </el-form-item>

            <el-form-item :label="$t('common.description')" prop="description">
                <el-input type="textarea" v-model="form.description"></el-input>
            </el-form-item>

            <el-form-item :label="$t('common.labor')" prop="labor">
                <el-input v-model.number="form.labor"></el-input>
            </el-form-item>

            <el-form-item :label="$t('common.maxTime')" prop="maxTime">
                <el-input v-model.number="form.maxTime"></el-input>
            </el-form-item>

        </el-form>
        <span slot="footer">
            <el-button :disabled="loading" type="primary" @click="save" v-if="$isFullAdmin">{{codeId === null ? $t('common.create') : $t('common.update')}}</el-button>
            <el-button :disabled="loading" @click="closeDialog">{{$t('common.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { ProductSelector, ResolutionCategorySelector } from '@/app/shared/components'
    import api from '../api'

    export default {
        name: 'create-update-resolution-code-dialog',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            codeId: {
                required: false
            }
        },
        components: {
            ProductSelector, ResolutionCategorySelector
        },
        data() {
            return {
                form: {
                    productId: undefined,
                    categoryId: undefined,
                    code: '',
                    description: '',
                    labor: null,
                    maxTime: null
                },
                rules: {
                    productId: [
                        {
                            type: 'number',
                            required: true,
                            message: this.$t('common.pleaseSelectProduct'),
                            trigger: 'change'
                        }
                    ],
                    categoryId: [
                        {
                            type: 'number',
                            required: true,
                            message: this.$t('common.pleaseSelectProduct'),
                            trigger: 'change'
                        }
                    ],
                    code: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterCode'),
                            trigger: 'blur'
                        }
                    ],
                    description: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEntercodeDescription'),
                            trigger: 'blur'
                        }
                    ],
                    labor: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterLabor'),
                        },
                        { type: 'number', message: this.$t('common.laborMustBeANumber') }
                    ],
                    maxTime: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterMaxTime'),
                        },
                        { type: 'number', message: this.$t('common.maxTimeMustBeANumber') }
                    ]
                },
                loading: false,
                showDialog: this.visible
            }
        },
        watch: {
            'form.productId': function (val, oldVal) {
                if (this.codeId && oldVal === undefined) {
                    return;
                }
            },
            visible: function (val) {
                this.showDialog = val
            }
        },
        methods: {
            loadCode() {
                if (this.codeId) {
                    this.loading = true
                    api.getCode(this.codeId).then(response => {
                        this.loading = false
                        this.form = Object.assign({}, response.data)
                    })
                }
            },
            closeDialog() {
                this.$refs['form'].resetFields()
                this.showDialog = false
                this.loading = false
                this.$emit('dialogClosed')
            },
            save() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.loading = true
                        api.saveCode(this.codeId, this.form).then(() => {
                            this.$emit('save', {
                                new: this.codeId === undefined,
                                id: this.codeId,
                                data: this.form
                            })
                            this.closeDialog()
                        })
                    } else {
                        return false
                    }
                })
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientApp/app/masters/resolutioncodes/components/CreateUpdateResolutionCodeDialog.vue